<template>
  <div class="wh100 mypannel" :class="pannelShadow">
    <div class="title-container" v-if="title" :style="titleStyle">
      <div class="title-left">
        <div class="icon">
          <slot name="icon">
            <div class="default-icon" v-if="defaultIcon"></div>
          </slot>
        </div>
        <div class="title">{{ title }}</div>
      </div>
      <div class="title-right">
        <slot name="title-right"></slot>
      </div>
    </div>
    <div class="content-container">
      <slot></slot>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    //标题，不传值时默认不显示标题
    title: {
      type: String,
      default: "",
    },
    //是否使用默认标题图标
    defaultIcon: {
      type: Boolean,
      default: true,
    },
    shadow: {
      type: String,
      default: "always",
    },
    //标题栏区域style
    titleStyle: {
      type: String,
      default: "",
    },
  },

  computed: {
    pannelShadow: function () {
      let className = "";
      switch (this.shadow) {
        case "always":
          className = "always-shadow";
          break;
        case "never":
          className = "";
          break;
        case "hover":
          className = "hover-shadow";
          break;
        default:
          className = "always-shadow";
          break;
      }
      return className;
    },
  },
};
</script>
<style lang="less" scoped>
.wh100 {
  height: 100%;
  width: 100%;
}
.mypannel {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #ebeef5;
}
.always-shadow {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.hover-shadow:hover {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.title-container {
  flex-grow: 0;
  height: 47px;
  padding: 0 15px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  border-bottom: 1px solid #e3e3e3;
  justify-content: space-between;
}
.title-left,
.title-right {
  height: 100%;
  display: flex;
  align-items: center;
}
.icon {
  margin-right: 10px;
  height: 100%;
  display: flex;
  align-items: center;
}
.default-icon {
  height: 35%;
  width: 4px;
  background: #04b7b8;
  border-radius: 25%;
}
.title {
  font-size: 16px;
}
.content-container {
  //display: flex;
  flex: 1;
  padding: 15px;
  box-sizing: border-box;
  height: 0;
}
</style>